module.exports = __webpack_public_path__ + "static/media/tayson.6cb998d1.png";